import { ContractsService } from '@/services/contracts.service'
import { CarsService } from '@/services/cars.service'

export default {
  getCurrent ({ commit }, contractNo) {
    return new Promise((resolve, reject) => {
      ContractsService.getById(contractNo)
        .then(contract => {
          if (contract.data) {
            CarsService.getById(contractNo).then(car => {
              const result = Object.assign({}, contract.data)
              if (car.data) {
                result.Car = car.data
              }
              commit('SET_CURRENT_CONTRACT', result)
              resolve(result)
            })
          }
        })
        .catch(error => commit('toast/NEW', {
          type: 'error',
          message: error.message
        }, { root: true }))
    })
  }
}
